<div class="language-select" [hidden]="availableLanguages?.length <= 1">
    <select class="form-control" [(ngModel)]="selectedLanguage" (ngModelChange)="switchLang()">
      <option [value]="language.value" *ngFor="let language of availableLanguages">{{language.display}}</option>
    </select>
</div>
